import React from 'react';
import { useParams } from 'react-router-dom';
import TituloSolo from '../components/sections/Gracias/TituloSolo'; 
import TituloGracias from '../components/sections/Gracias/TituloGracias';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

function Gracias() {
  const { producto } = useParams();

  return (
    <div>
      <Header />
      <TituloSolo />
      {/* el link de la página de gracias es dinámica es: http://localhost:3000/gracias/pisos-spc 
      <TituloGracias producto={producto} /> */}
       <TituloGracias producto={producto}/>
      <Footer /> 
    </div>
  );
}

export default Gracias;